export interface ProductTypeReport {
  id: string;
  name: string;
  uniqueCustomers: number;
  orders: number;
}

export interface Report {
  currency: string;
  totalRevenueCollected: number;
  totalDiscounts: number | null;
  totalRefunds: number | null;
  totalUniqueCustomers: number;
  totalOrders: number;
  productTypes: ProductTypeReport[];
  lastUpdatedAt?: string;
}

function toProductTypeReport(data: any): ProductTypeReport {
  return {
    id: data.id,
    name: data.name,
    uniqueCustomers: data.unique_customers,
    orders: data.orders,
  };
}

export function toReport(data: any): Report {
  return {
    currency: data.currency,
    totalRevenueCollected: data.total_revenue_collected,
    totalDiscounts: data.total_discounts,
    totalRefunds: data.total_refunds,
    totalUniqueCustomers: data.total_unique_customers,
    totalOrders: data.total_orders,
    productTypes: data.product_types.map(toProductTypeReport),
    lastUpdatedAt: data?.last_updated_at,
  };
}

export interface FinancialData {
  totalTaxes: number;
  totalProcessingFees: number;
  totalTakeRatesAmount: number;
  totalDiscounts: number;
  totalRefunds: number;
  totalPayouts: number;
  totalRevenue: number;
}

export interface Payout {
  payoutCostCenterId: string;
  payoutCostCenterName: string;
  payoutId: string;
  minAmountPerLocation: number;
  locationCount: number;
  totalMinimumCharge: string;
  appliedMinimumCharge: boolean;
  payoutCurrency: string;
  onDemandCsvFileName: string | null;
  subscriptionCsvFileName: string;
  onDemand?: FinancialData;
  membership?: FinancialData;
  total?: FinancialData;
}

export function toPayoutData(data: any): Payout | undefined {
  if (!data) {
    return;
  }

  return {
    payoutCostCenterId: data.payout_cost_center_id,
    payoutCostCenterName: data.payout_cost_center_name,
    payoutId: data.payout_id,
    minAmountPerLocation: data.min_amount_per_location,
    locationCount: data.location_count,
    totalMinimumCharge: data.total_minimum_charge,
    appliedMinimumCharge: data.applied_minimum_charge,
    payoutCurrency: data.payout_currency,
    onDemandCsvFileName: data.on_demand_csv_file_name,
    subscriptionCsvFileName: data.subscription_csv_file_name,
    onDemand: toOnDemandOrMembershipPayoutData(data.on_demand),
    membership: toOnDemandOrMembershipPayoutData(data.membership),
    total: toOnDemandOrMembershipPayoutData(data.total),
  };
}

export function toOnDemandOrMembershipPayoutData(
  data: any
): FinancialData | undefined {
  if (!data) {
    return;
  }

  return {
    totalTaxes: data.total_taxes,
    totalProcessingFees: data.total_processing_fees,
    totalTakeRatesAmount: data.total_take_rates_amount,
    totalDiscounts: data.total_discounts,
    totalRefunds: data.total_refunds,
    totalPayouts: data.total_payouts,
    totalRevenue: data.total_revenue,
  };
}
